import React from 'react';
import { Nav } from '@/components/nav';
import { useRouter } from 'next/router';
import { Meta } from '@/components/meta';

export default function CopyrightDisclaimer() {
  const router = useRouter();

  return (
    <>
      {/* when rendering in levelapp webview, website must not load nav */}
      {router.query.source !== `levelapp` && <Nav />}

      <Meta
        title="Copyright Disclaimer - Level Game"
        url="https://level.game/copyright-disclaimer"
      />

      {/* eslint-disable-next-line */}
      <style jsx>{`
        a {
          text-decoration: underline;
        }
      `}</style>

      <div className="container max-w-6xl px-10 mx-auto text-gray-300">
        <h1 className="mt-10 mb-5 text-2xl font-bold text-center">
          Copyright Disclaimer
        </h1>

        {/* eslint-disable */}

        <p className="my-4">
          This website and its content, including the text, images, videos,
          graphics, photographs, sound recordings, user interface, and any other
          content provided on this website, is the copyright of Level Fit Tech
          Pvt. Ltd. ("<strong>Level</strong>") and is protected by the laws of
          India and international copyright laws. Except with our prior written
          consent, you are prohibited from copying, reproducing, distributing,
          modifying, performing, displaying or transmitting any of the contents
          of this website for any purpose, and nothing otherwise stated or
          implied herein confers on you any right or license to do so.
        </p>

        <p className="my-4">
          You may use the services and the content contained herein solely for
          your own individual, personal, informational, and non-commercial
          purposes only. Any other use of the content, including for any
          commercial purposes, is strictly prohibited without our express
          written consent.
        </p>

        <p className="my-4">
          You agree not to archive, reproduce, distribute, modify, display,
          perform, publish, license, create derivative works from, offer sale,
          or use (except as explicitly authorized by us in writing) the content
          on this website.
        </p>

        <p className="my-4">
          You agree that the systematic retrieval of data or other content from
          this website, whether to create, compile, directly or indirectly, a
          collection, compilation, directory, or database, is prohibited unless
          expressly consented to by us in writing.
        </p>

        {/* eslint-enable */}
        <div className="pb-40" />
      </div>
    </>
  );
}
